import React from 'react'
import MarkImprovedPage from './MarkImprovedPage'
import '../styles/index.scss'

function MarkImprovedContainer() {
    return (
        <div className='MarkImprovedContainer'>
            <MarkImprovedPage />
        </div>
    )
}

export default MarkImprovedContainer
